import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { parseArray, stringifyFormatted, safeDeepGetWithType, parse, stringify, safeDeepGet } from 'iotera-base/json';
import { isEmpty, isNone } from 'iotera-base/object';

import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { domainIsTenant as dit, S } from '../../../routes/routes'

import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Json Editor */
import JsonEditor from '../../../lib/components/JsonEditor'

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import './style.scss'
import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeaderStep } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { addDeviceConfig, goToURLActivation, selectCategory, storeDeviceConfig } from '../function';

const schema = {
  type: "object",
  required: ["sensors"],
  properties: {
    sensors: { type: "string", title: 'Konfigurasi', minLength: 0 },
  }
};

const uiSchema = {
  sensors: {
    "ui:widget": (props) => {
      return (
        <div style={{ padding: 1, border: '1px solid #CED4DA' }}>
          <JsonEditor {...props} />
        </div>
      )
    },
  }
};

class Example extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: [],
      formData: {},
      loading: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ formData: event.formData })
  }

  handleSubmit() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let submitData = safeDeepGetWithType(_state, ['formData'])
    if (isEmpty(submitData)) {
      let storeValue = store.getState()
      submitData = safeDeepGet(storeValue, ['device'])
    }
    const sensors = safeDeepGetWithType(submitData, ['sensors'])
    let sensors_object = parse(sensors);
    if (isNone(sensors_object)) {
      sensors_object = parseArray(sensors);
    }
    if (isNone(sensors_object)) {
      submitData = addDeviceConfig(submitData, stringify(sensors_object))
      storeDeviceConfig(submitData)
      _props.showSingleNotification({ message: 'Konfigurasi harus dalam bentuk JSON yang benar', level: 'warning' });
      return;
    }
    submitData = addDeviceConfig(submitData, stringifyFormatted(sensors_object))
    storeDeviceConfig(submitData)
    let category = submitData['category'];
    let selectedCategory = selectCategory(category)
    goToURLActivation({ ..._props }, selectedCategory) // function for history.push to one of page activation
  }
  goBack() {
    this.props.history.push('.' + S + 'info')
  };

  render() {
    const _this = this
    const _props = _this.props
    const _state =_this.state
    const { formData } = _state
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (!isEmpty(formData)) {
      dataToShow = formData
    }
    else {
      if (isEmpty(dataToShow)) {
        _this.goBack();
      } else {
        if ('device' in dataToShow) {
          if (isEmpty(dataToShow.device)) {
            _this.goBack();
          }
          else {
            dataToShow = dataToShow.device;
          }
        }
        else {
          _this.goBack();
        }
      }
    }
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Perangkat' subTitle='Permohonan tambah perangkat baru' 
        steps={['Kategori', 'Informasi', 'Konfigurasi', 'Aktivasi']} activeStep={2} />
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema}
            uiSchema={uiSchema}
            onChange={_this.handleChange}
            onSubmit={_this.handleSubmit}
            formData={dataToShow}
          >
            <div className="button-right" style={{ marginTop: 10 }}>
              <Button variant="outlined" size="large" style={{ minWidth: '0%' }} 
              onClick={_props.history.goBack} >Kembali</Button>
              <Button variant="contained" size="large" color="primary" type="submit" 
              style={{ marginLeft: 10, minWidth: '0%' }}> Berikutnya </Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(null, mapDispatchToProps)(withRouter(Example));